// Import variables
import { ALL_OPERATORS, DOCUMENT_OPERATORS, REGULATION_OPERATORS, CONFIGURATOR_OPERATORS } from 'helpers/operators';
import { USER_PATHS } from './paths';

export const NAV_LINKS = [
	{
		path: USER_PATHS.PROFILE,
		translation: 'navigation_general',
		key: 'profil',
		operators: ALL_OPERATORS
	},
	{
		path: USER_PATHS.PACKETS,
		translation: 'navigation_your_packets',
		key: 'twoje-pakiety',
		operators: CONFIGURATOR_OPERATORS
	},
	{
		path: USER_PATHS.PRODUCTS,
		translation: 'navigation_active_products_vectra',
		key: 'aktywne-wypozyczenia',
		operators: ALL_OPERATORS
	},
	{
		path: USER_PATHS.PAYMENTS,
		translation: 'navigation_payments_vectra',
		key: 'historia-platnosci',
		operators: ALL_OPERATORS
	},
	{
		path: USER_PATHS.FAVOURITES,
		translation: 'navigation_favourites',
		key: 'ulubione',
		operators: ALL_OPERATORS
	},
	{
		path: USER_PATHS.DEVICES,
		translation: 'navigation_devices',
		key: 'urzadzenia',
		operators: ALL_OPERATORS
	},
	{
		path: USER_PATHS.PAYMENT_METHOD,
		translation: 'navigation_payment_method',
		key: 'metoda-platnosci',
		operators: ALL_OPERATORS
	},
	{
		path: USER_PATHS.AGREEMENTS,
		translation: 'navigation_zgody',
		key: 'zgody',
		operators: CONFIGURATOR_OPERATORS
	},
	{
		path: USER_PATHS.DOCUMENTS,
		translation: 'navigation_documents',
		key: 'dokumenty',
		operators: DOCUMENT_OPERATORS
	},
	{
		path: USER_PATHS.REGULATIONS,
		translation: 'navigation_regulation',
		key: 'regulamin',
		operators: REGULATION_OPERATORS
	}
];
